<template>
  <div class="card card-shadow" v-if="subtestAttempts.length > 0">
    <div class="card-header d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
      <h1 class="h4">{{ translate('tables.subtest-attempts.title') }}</h1>
    </div>
    <div class="card-body p-0">
      <table class="table card-table mb-0">
        <thead>
        <tr class="bg-light text-muted">
          <th>#</th>
          <th>{{ translate('tables.subtest-attempts.columns.test') }}</th>
          <th>{{ translate('tables.subtest-attempts.columns.test_variation') }}</th>
          <th>{{ translate('tables.subtest-attempts.columns.subtest_type') }}</th>
          <th>{{ translate('tables.subtest-attempts.columns.student') }}</th>
          <th>{{ translate('tables.subtest-attempts.columns.writing_deadline') }}</th>
          <th>{{ translate('tables.subtest-attempts.columns.reviewer') }}</th>
          <th>{{ translate('tables.subtest-attempts.columns.speaking_appointment') }}</th>
          <th>{{ translate('tables.subtest-attempts.columns.status') }}</th>
          <th>{{ translate('tables.subtest-attempts.columns.grade') }}</th>
          <th>{{ translate('tables.subtest-attempts.columns.transaction') }}</th>
          <th>{{ translate('tables.subtest-attempts.columns.details') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="subtestAttempt in subtestAttempts">
          <td>{{ subtestAttempt.id }}</td>
          <td>
            <img :src="subtestAttempt.subtest.test_type.icon_path" class="icon" alt="icon">
          </td>
          <td>{{ subtestAttempt.subtest.test_variation['title_' + app.locale] }}</td>
          <td>{{ subtestAttempt.subtest.subtest_type['title_' + app.locale] }}</td>
          <td>{{ subtestAttempt.student ? subtestAttempt.student.name : '' }}</td>
          <td v-if="subtestAttempt.writing_deadline">{{ subtestAttempt.writing_deadline | datetime }}</td>
          <td v-else>{{ translate('tables.subtest-attempts.no_writing') }}</td>
          <td>{{ subtestAttempt.reviewer ? subtestAttempt.reviewer.name : '' }}</td>
          <td v-if="subtestAttempt.speaking_appointment_at">{{ subtestAttempt.speaking_appointment_at | datetime }}</td>
          <td v-else>{{ translate('tables.subtest-attempts.no_speaking') }}</td>
          <td v-if="subtestAttempt.subtest.subtest_type.name === 'writing' &&
                      subtestAttempt.writing_status === 'cancelled' ||
                      subtestAttempt.subtest.subtest_type.name === 'speaking' &&
                      subtestAttempt.speaking_status === 'cancelled'">
                      <span class="badge badge-danger">
                        {{ translate('subtest-attempts.canceled_status.cancelled') }}
                      </span>
          </td>
          <td v-else-if="subtestAttempt.subtest.subtest_type.name === 'complete'">
            <div v-if="subtestAttempt.writing_status === 'cancelled' && subtestAttempt.speaking_status === 'cancelled'">
                        <span class="badge badge-danger">
                          {{ translate('subtest-attempts.canceled_status.cancelled') }}
                        </span>
            </div>
            <div v-else>
                        <span :class="subtestAttemptStatusClass(subtestAttempt)">
                          {{ translate('statuses.' + subtestAttempt.status) }}
                        </span>
              <br>
              <div v-if="subtestAttempt.writing_status === 'cancelled'" class="badge badge-danger text-left">
                {{ translate('subtest-attempts.canceled_status.writing.cancelled') }}
              </div>
              <div v-if="subtestAttempt.speaking_status === 'cancelled'" class="badge badge-danger text-left">
                {{ translate('subtest-attempts.canceled_status.speaking.cancelled') }}
              </div>
            </div>
          </td>
          <td v-else>
                      <span :class="subtestAttemptStatusClass(subtestAttempt)">
                        {{ translate('statuses.' + subtestAttempt.status) }}
                      </span>
          </td>
          <td v-if="subtestAttempt.grade">{{ subtestAttempt.grade }}</td>
          <td v-else>{{ translate('tables.subtest-attempts.not_graded') }}</td>
          <td>{{ subtestAttempt.payment.stripe_description }}</td>
          <td>
            <a class="btn btn-link" :href="'/admin/subtest-attempts/' + subtestAttempt.id">
              {{ translate('tables.subtest-attempts.columns.details') }}
            </a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-else class="alert alert-info w-50" role="alert">
    <span class="fa fa-info-circle mr-2"></span>{{ translate('tables.subtest-attempts.empty') }}
  </div>
</template>

<script>
export default {
  mixins: [require('../../../../../resources/js/mixin')],

  data () {
    return {
      subtestAttempts: []
    };
  },

  mounted () {
    this.getSubtestAttempts();
  },

  methods: {
    subtestAttemptStatusClass (subtestAttempt) {
      if (subtestAttempt.status === 'created') {
        return 'badge badge-secondary';
      }

      if (subtestAttempt.status === 'submitted') {
        return 'badge badge-info text-white';
      }

      if (subtestAttempt.status === 'in-review') {
        return 'badge badge-primary';
      }

      if (subtestAttempt.status === 'completed') {
        return 'badge badge-success';
      }
    },

    /**
     * Get the SubtestAttempts.
     */
    getSubtestAttempts () {
      let self = this;

      axios.get('/api/subtest-attempts')
        .then(function (response) {

          self.subtestAttempts = response.data.subtestAttempts;
          console.log('self.subtestAttempts', self.subtestAttempts);

        });
    },
  }
};
</script>

<style>
.icon {
    height: 22px;
}
</style>
